export default {
  our_next_competition: {
    en: 'Our next competition',
    fr: 'Notre prochaine compétition',
  },
  our_next_event: {
    en: 'Our next event',
    fr: 'Notre prochain événement',
  },
  passionate_students_title: {
    en: 'Passionate students',
    fr: 'Étudiants passionnés',
  },
  passionate_students_content: {
    en: 'Join our team and be part of the next generation of search and rescue robots. We are looking for passionate students who want to make a difference in the world of robotics.',
    fr: 'Rejoignez notre équipe et faites partie de la prochaine génération de robots de recherche et de sauvetage. Nous recherchons des étudiants passionnés qui veulent faire une différence dans le monde de la robotique.',
  },
  social_title: {
    en: 'Social',
    fr: 'Social',
  },
  social_content: {
    en: 'Our team not only does research and development, we also organize social events to strengthen bonds between members. Join us to learn more!',
    fr: 'Notre équipe ne fait pas seulement de la recherche et du développement, nous organisons également des événements sociaux pour renforcer les liens entre les membres. Rejoignez-nous pour en savoir plus!',
  },
  nuclear_plant_title: {
    en: 'Nuclear Power Plant',
    fr: 'Centrale Nucléaire',
  },
  i_will_be_there: {
    en: 'Regester',
    fr: "M'inscrire",
  },
  information_evening_title: {
    en: 'Information Evening',
    fr: "Soirée d'information",
  },
  information_evening_content: {
    en: 'We will present our club and our various projects for each department. This session is intended for all students wanting to learn more about our club, regardless of their field of study or level of experience.',
    fr: "Nous allons présenter notre club et nos divers projets pour chaque département. Cette séance est destiné à tous les étudiants voulant en apprendre plus sur notre club, peu importe leur domaine d'étude ou leur degré d'expérience.",
  },
  treat_pizza: {
    en: "and we'll treat you with pizza!",
    fr: "et on t'offre la pizza!",
  },
  meet_us: {
    en: 'Come meet us on',
    fr: 'Viens nous rencontrer le',
  },
  at_time: {
    en: 'at',
    fr: 'à',
  },
  at_location: {
    en: 'at',
    fr: 'au',
  },
  custom_robot_title: {
    en: 'Custom Robot',
    fr: 'Robot sur mesure',
  },
  custom_robot_content: {
    en: 'Our robots are tailor-made to perform specific tasks in harsh environments. From object detection to path planning, they are designed to be efficient in their operations. So, each part of our robot is custom designed by our team.',
    fr: "Nos robots sont conçus sur mesure pour effectuer des tâches spécifiques dans des environnements difficiles. De la détection d'objets à la planification de trajectoires, ils sont conçus pour être efficaces dans leurs opérations. Donc, chaques pièces de notre robot est conçu sur mesure par notre équipe.",
  },
  robot_optimisation_title: {
    en: 'Robot Optimisation',
    fr: 'Optimisation du Robot',
  },
  robot_optimisation_content: {
    en: 'Our robots are optimized to perform complex tasks with precision and efficiency. From motor control to sensor interface, they are designed to be reliable and robust in their operations. Each part is therefore optimized to be as efficient as possible.',
    fr: "Nos robots sont optimisés pour effectuer des tâches complexes avec précision et efficacité. Du contrôle moteur à l'interface de capteur, ils sont conçus pour être fiables et robustes dans leurs opérations. Chaques pièces est donc optimisé pour être le plus performant possible.",
  },
  pcb_design_title: {
    en: 'PCB Design',
    fr: 'Conception de PCB',
  },
  pcb_design_content: {
    en: 'Our robots are equipped with cutting-edge equipment that allows them to perform certain tasks. However, some specific needs require personalized electronic cards. This is why we design custom PCBs.',
    fr: "Nos robots sont équipés de matériel de pointe qui leur permet d'effectuer certaines tâches. Cependant, certains besoins spécifiques nécessitent des cartes électroniques personnalisées. C'est pourquoi nous concevons des PCB sur mesure.",
  },
  electrical_stack_title: {
    en: 'Electrical Stack',
    fr: 'Batterie',
  },
  electrical_stack_content: {
    en: 'Our robots are equipped with a wide range of electrical components such as motor drivers to power supplies. We therefore have an electric stack that allows our robots to be reliable and robust in their operations while being safe.',
    fr: "Nos robots sont équipés d'une large gamme de composants électriques tels que des contrôleurs de moteur aux alimentations électriques. Nous avons donc une pile électrique qui permet à nos robots d'être fiables et robustes dans leurs opérations tout en étant sécuritaire.",
  },
  ai_title: {
    en: 'AI - Machine Learning',
    fr: 'IA - Apprentissage Machine',
  },
  ai_content: {
    en: 'During our challenges, our robots must be able to identify objects and people. Our AIs are therefore trained using machine learning algorithms to be effective in emergency scenarios.',
    fr: "Durant nos épreuves, nos robots doivent être capables d'identifier des objets et des personnes. Nos IA sont donc entraînés à l'aide d'algorithmes d'apprentissage machine pour être éfficace lors des scénarios d'urgence.",
  },
  mapping_title: {
    en: 'Mapping & Autonomy',
    fr: 'Cartographie & Autonomie',
  },
  mapping_content: {
    en: 'During our competitions, our robots must be capable of making autonomous decisions. To achieve this, they are equipped with 3D mapping, path planning and autonomy systems that allow them to navigate difficult terrain.',
    fr: "Durant nos compétitions, nos robots doivent être capables de prendre des décisions autonomes. Afin de réaliser cela, ils sont équipés de systèmes de cartographie 3D, de planification de trajectoires et d'autonomie qui leur permettent de naviguer dans des terrains difficiles.",
  },
  team: {
    en: 'Team',
    fr: 'Équipe',
  },
  team_history: {
    en: 'Team History',
    fr: 'Historique de notre club',
  },
};
